import React, { memo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import ChevronDownSvg from 'images/v5/icons/chevron-down.svg';
import InformationSvg from 'images/v5/icons/circle/information.svg';
import Button from 'layout/atoms/Button/Button';
import Dropdown from 'layout/atoms/Dropdown/Dropdown';
import Loader from 'layout/atoms/Loader/Loader';
import { Cell, Row } from 'layout/atoms/TableGrid';
import Grid from 'molecules/Grid/Grid';
import { fetchCurrencies, fetchGlobalExchangeRates, selectCurrencies, selectCurrenciesErrors, selectCurrenciesRefetchFlags, selectCurrenciesStatus, selectGlobalExchangeRates, selectToCurrency, setToCurrency, } from 'store/parameters/currenciesSlice';
import ParametersTable from '../shared/ParametersTable';
function ExchangeRates() {
    const dispatch = useDispatch();
    const { t } = useTranslation(['specification', 'common']);
    const currencies = useSelector(selectCurrencies);
    const globalExchangeRates = useSelector(selectGlobalExchangeRates);
    const toCurrency = useSelector(selectToCurrency);
    const status = useSelector(selectCurrenciesStatus);
    const errors = useSelector(selectCurrenciesErrors);
    const refetchFlags = useSelector(selectCurrenciesRefetchFlags);
    useEffect(() => {
        if (status.fetch === 'idle' || refetchFlags.fetch) {
            dispatch(fetchCurrencies());
        }
        if (status.fetchGlobalExchangeRates === 'idle' || refetchFlags.fetchGlobalExchangeRates) {
            dispatch(fetchGlobalExchangeRates(toCurrency));
        }
    }, [
        dispatch,
        status.fetch,
        status.fetchGlobalExchangeRates,
        refetchFlags.fetch,
        refetchFlags.fetchGlobalExchangeRates,
        toCurrency,
    ]);
    const handleCurrencyChange = ({ toCurrencyId, currencyIsoCode, }) => {
        dispatch(setToCurrency({
            toCurrencyId,
            currencyIsoCode,
        }));
        dispatch(fetchGlobalExchangeRates({
            toCurrencyId,
            currencyIsoCode,
        }));
    };
    if (status.fetch === 'loading' || status.fetch === 'idle') {
        return React.createElement(Loader, null);
    }
    if (status.fetch === 'failed') {
        return React.createElement("div", null, errors.fetch);
    }
    return (React.createElement(Grid, { gap: 24 },
        React.createElement("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' } },
            React.createElement("div", { style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    color: 'var(--static-text-subtle)',
                } },
                React.createElement(InformationSvg, null),
                React.createElement("span", null, t('currencies_synchronised_with_frankfurter_api'))),
            React.createElement(Dropdown, { trigger: React.createElement(Button, { rightIcon: React.createElement(ChevronDownSvg, null), theme: "border" }, (toCurrency === null || toCurrency === void 0 ? void 0 : toCurrency.currencyIsoCode) && toCurrency.currencyIsoCode !== 'all'
                    ? toCurrency.currencyIsoCode.toUpperCase()
                    : t('common:quote_currency')) },
                React.createElement(Button, { align: "left", theme: !(toCurrency === null || toCurrency === void 0 ? void 0 : toCurrency.currencyIsoCode) ? 'fill' : 'ghost', onClick: () => handleCurrencyChange({ toCurrencyId: 'all', currencyIsoCode: '' }) }, t('common:all_v1')),
                currencies.map((currency) => (React.createElement(Button, { key: currency.isoCode, align: "left", theme: (toCurrency === null || toCurrency === void 0 ? void 0 : toCurrency.currencyIsoCode) === currency.isoCode ? 'fill' : 'ghost', onClick: () => handleCurrencyChange({
                        toCurrencyId: currency.id,
                        currencyIsoCode: currency.isoCode,
                    }) }, currency.isoCode.toUpperCase()))))),
        React.createElement(ParametersTable, { columns: [
                ['200px', '1fr'],
                ['180px', '240px'],
            ], headers: [{ content: t('currency_pair') }, { content: t('common:exchange_rate') }] }, globalExchangeRates.map((exchangeRate) => (React.createElement(Row, { key: exchangeRate.id },
            React.createElement(Cell, null,
                exchangeRate.currencyFrom.isoCode.toUpperCase(),
                "/",
                exchangeRate.currencyTo.isoCode.toUpperCase()),
            React.createElement(Cell, null, exchangeRate.rate != null ? Number(exchangeRate.rate).toFixed(2) : '-')))))));
}
export default memo(ExchangeRates);
